import EventStrip from './EventStrip';

export default EventStrip;
